module.exports = __webpack_public_path__ + "static/media/mr-status.0aa47bfd.svg";